import script from "./newInput.vue?vue&type=script&setup=true&lang=js"
export * from "./newInput.vue?vue&type=script&setup=true&lang=js"

import "./newInput.vue?vue&type=style&index=0&id=6a4c6c12&lang=scss"

const __exports__ = script;

export default __exports__